<div class="card panel-flat-color primary-panel flex-panel">
    <div class="panel-flat-header d-flex">
        <h3 class="ws-flex-auto ws-truncate">Form Template [All Tax Years - All Assessors]</h3>
        <div class="ws-flex-none header-button-container">
            @if (canEdit) {
                <button type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="upload()"
                        [disabled]="!canEnterEditMode"
                        helpTooltip
                        helpContentId="app.upload"
                        position="bottom">
                    <i class="fa fa-upload fa-align"></i>
                </button>
            }
            @if (!isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="expandComponent()">
                    <i class="fa fa-arrows-alt"
                       helpTooltip
                       helpContentId="app.expand"
                       position="bottom"></i>
                </button>
            }
            @if (isExpanded) {
                <button type="button" class="ace-btn btn-text has-icon btn-secondary" (click)="collapseComponent()">
                    <i class="fa fa-compress"
                       helpTooltip
                       helpContentId="app.collapse"
                       position="bottom"></i>
                </button>
            }
        </div>
    </div>
    <div class="panel-flat-body">
        @if (formRevision && !formRevision.hasTemplate) {
            <div class="no-data">
                The form doesn't have a template
            </div>
        }
        @if (formRevision && formRevision.hasTemplate) {
            <table class="table table-condensed table-hover table-borderless">
                <tbody>
                    <tr>
                        <td>
                            <span>
                                @if (formRevision.isFormConsolidated) {
                                    <i
                                        class="consolidated-icon fa fa-sitemap"
                                        helpTooltip
                                        helpContentId="form.is-form-consolidated">
                                    </i>
                                }
                                {{ formRevision.templateSafeFileName }}
                            </span>
                            @if (formRevision.isPlaceholderTemplate) {
                                <span> (Placeholder)</span>
                            }
                            @if (canEdit && (!formRevision.isPlaceholderTemplate || formRevision.templateChangeDate)) {
                                <span>(Last changed by {{ formRevision.templateChangedBy }}
                                    on {{ formRevision.templateChangeDate | date: 'MM/dd/yyyy h:mm a' }})</span>
                            }
                            @if (hasErrors) {
                                <a class="ace-btn btn-link"
                                   helpTooltip
                                   tooltipText="The template has validation errors"
                                   position="bottom"
                                   (click)="showValidations()">
                                    <i class="fa fa-warning template-validation-errors"></i>
                                </a>
                            }
                        </td>
                        <td>
                            <div class="float-end">
                                @if (canEdit && !formRevision.isPlaceholderTemplate) {
                                    <button class="ace-btn has-icon btn-secondary"
                                            helpTooltip
                                            helpContentId="app.edit"
                                            position="bottom"
                                            (click)="edit()"
                                            [disabled]="!canEnterEditMode">
                                        <i class="fa fa-pencil fa-align"></i>
                                    </button>
                                }
                                <button class="ace-btn has-icon btn-secondary"
                                        helpTooltip
                                        helpContentId="app.download"
                                        position="bottom"
                                        (click)="download()"
                                        [disabled]="!canEnterEditMode">
                                    <i class="fa fa-download fa-align"></i>
                                </button>
                                <button class="ace-btn has-icon btn-secondary"
                                        helpTooltip
                                        helpContentId="app.validate"
                                        position="bottom"
                                        (click)="validate()"
                                        [disabled]="!canEnterEditMode">
                                    <i class="fa fa-bug fa-align"></i>
                                </button>
                                @if (canEdit) {
                                    <button class="ace-btn has-icon btn-primary btn-danger"
                                            helpTooltip
                                            helpContentId="app.delete"
                                            position="bottom"
                                            (click)="delete()"
                                            [disabled]="(!canEnterEditMode) || formRevision.isPlaceholderTemplate">
                                        <i class="fa fa-trash fa-align"></i>
                                    </button>
                                }
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        }
    </div>
</div>
